if (process.env.NODE_ENV === 'production' && window.WEBPACK_PUBLIC_PATH) {
  __webpack_public_path__ = window.WEBPACK_PUBLIC_PATH;
}
